import { render, staticRenderFns } from "./CharacteristicService.vue?vue&type=template&id=4ee7b109&"
import script from "./CharacteristicService.vue?vue&type=script&lang=js&"
export * from "./CharacteristicService.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports